var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Clear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M7.629,27.344c7,13.656,21,14.656,21,14.656c5.031-4.802,8.534-12.235,8.534-12.235l-14.778-8.403C22.385,21.361,16.066,28.691,7.629,27.344z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E5FC",
    d: "M8 6A2 2 0 1 0 8 10 2 2 0 1 0 8 6zM14.5 8A1.5 1.5 0 1 0 14.5 11 1.5 1.5 0 1 0 14.5 8zM13 13A3 3 0 1 0 13 19 3 3 0 1 0 13 13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M36.277,21.209l-0.481,0.877l-6.099-3.469l0.494-0.869l7.291-10.984c0.735-0.911,2.108-0.988,3.147-0.333c1.067,0.547,1.636,1.734,1.248,2.719L36.277,21.209z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M35.408,20.714l-4.348-2.471c-3.477-1.978-6.204-1.229-8.181,2.249l-0.495,0.869l14.778,8.403l0.494-0.868C39.635,25.42,38.884,22.692,35.408,20.714z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    d: "M20.145,23.438c0.286,0.636,0.765,1.558,1.52,2.091c0.022,0.017,0.048,0.024,0.071,0.04c0,0,0,0.001,0.001,0.002c0.962,0.678,2.151,0.929,3.551,0.759c0.265,0.714,0.747,1.563,1.633,2.188c0.021,0.015,0.047,0.023,0.07,0.039c0,0.001,0,0.001,0.002,0.001c0.964,0.68,2.148,0.93,3.549,0.76c0.267,0.715,0.748,1.563,1.633,2.188c0.115,0.082,0.234,0.158,0.355,0.227c0.059,0.034,0.129,0.05,0.189,0.079c0.83,0.44,1.989,0.592,3.098,0.485c1.013-1.632,1.347-2.532,1.347-2.532l-14.778-8.403C21.438,22.31,21.454,22.28,20.145,23.438z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "M14.564 34.255c1.268-.162 5.436-.838 8.145-5.088-3.708 4.25-10.829 3.242-12.22 2.657.717.915 1.467 1.744 2.236 2.503C13.22 34.359 13.815 34.346 14.564 34.255zM17.243 37.913c1.197.755 2.382 1.375 3.508 1.879.005.002.015.006.02.008.318-.092.663-.206 1.054-.363 1.32-.678 4.341-2.27 6.884-6.229C24.791 37.495 19.633 37.889 17.243 37.913z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Clear);
export default __webpack_public_path__ + "static/media/icons8-clear.8d100ed40770c52484a72a7be7e14063.svg";
export { ForwardRef as ReactComponent };